/**
 * Wishlist Page
 * Renders wishlist products from handles stored by wishlist.js.
 */
;(function (window, $) {
  'use strict';

  if (!$) {
    return;
  }

  var WishlistPage = {
    selectors: {
      page: '.wishlist-page',
      grid: '.wishlist-grid',
      container: '.wishlist-products-container',
      empty: '.wishlist-grid-empty-list',
      loader: '.wishlist-loader'
    },
  
    init: function () {
      if (!$(this.selectors.page).length) {
        return;
      }

      if (!window.Wishlist) {
        return;
      }

      this.bindEvents();
      this.loadCurrentWishlist();
    },

    loadCurrentWishlist: function () {
      var handles = window.Wishlist.getList();
      if (!handles.length) {
        this.showEmpty();
        return;
      }

      this.loadProducts(handles);
    },

    loadProducts: function (handles) {
      var self = this;
      var validHandles = [];
      var products = [];
      var index = 0;
      var safeHandles = Array.isArray(handles) ? handles.slice(0) : [];

      this.showLoading();
      $(this.selectors.container).empty();

      var loadNext = function () {
        if (index >= safeHandles.length) {
          self.finishProductLoad(safeHandles, validHandles, products);
          return;
        }

        var handle = safeHandles[index];
        index += 1;

        self.fetchProduct(handle)
          .done(function (product) {
            validHandles.push(handle);
            products.push(product);
          })
          .always(loadNext);
      };

      loadNext();
    },

    fetchProduct: function (handle) {
      return $.ajax({
        url: '/products/' + encodeURIComponent(handle) + '.js',
        dataType: 'json',
        cache: false
      });
    },

    finishProductLoad: function (requestedHandles, validHandles, products) {
      var self = this;
      var i;

      if (requestedHandles.length !== validHandles.length) {
        window.Wishlist.replace(validHandles);
      }

      if (!products.length) {
        this.showEmpty();
        return;
      }

      for (i = 0; i < products.length; i += 1) {
        this.renderProduct(products[i]);
      }

      this.hideLoading();
      this.showGrid();

      // Ensure rendered remove buttons and counters are in sync.
      window.Wishlist.syncButtons(validHandles);

      // Re-run in case all products were invalid and replaced.
      if (!validHandles.length) {
        window.setTimeout(function () {
          self.showEmpty();
        }, 0);
      }
    },

    getStrings: function () {
      var strings = window.wishlistStrings || {};
      return {
        addToCart: strings.addToCart || 'Add to cart',
        added: strings.added || 'Added',
        outOfStock: strings.outOfStock || 'Out Of Stock',
        buyNow: strings.buyNow || 'Buy Now',
        confirmClear: strings.confirmClear || 'Are you sure you want to clear your wishlist?',
        addError: strings.addError || 'Could not add to cart. Please try again.'
      };
    },

    escapeHtml: function (text) {
      if (text === null || text === undefined) {
        return '';
      }

      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    getDefaultVariant: function (product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var i;

      for (i = 0; i < variants.length; i += 1) {
        if (variants[i].available) {
          return variants[i];
        }
      }

      return variants.length ? variants[0] : null;
    },

    formatMoney: function (cents) {
      var value = typeof cents === 'number' ? cents : 0;
      var moneyFormat =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify && window.Shopify.money_format) ||
        '${{amount}}';

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(value, moneyFormat);
      }

      var amount = (value / 100).toFixed(2);
      var amountNoDecimals = String(Math.round(value / 100));

      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    },

    buildPriceHtml: function (product) {
      var price = typeof product.price === 'number' ? product.price : 0;
      var compareAtPrice =
        typeof product.compare_at_price === 'number' ? product.compare_at_price : 0;

      if (compareAtPrice > price) {
        return (
          '<span class="price-sale">' +
          this.formatMoney(price) +
          '</span><span class="compare-price">' +
          this.formatMoney(compareAtPrice) +
          '</span>'
        );
      }

      return '<span class="pro-price">' + this.formatMoney(price) + '</span>';
    },

    buildVariantSelectorHtml: function (product, defaultVariant) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var hasVariants = variants.length > 1;
      var html = '';
      var i;

      if (!hasVariants) {
        return '';
      }

      html += '<select class="wishlist-variant-select" data-product-id="' + product.id + '">';
      for (i = 0; i < variants.length; i += 1) {
        var variant = variants[i];
        var selected = defaultVariant && variant.id === defaultVariant.id ? ' selected' : '';
        var disabled = variant.available ? '' : ' disabled';
        html +=
          '<option value="' +
          variant.id +
          '" data-available="' +
          (variant.available ? '1' : '0') +
          '"' +
          selected +
          disabled +
          '>' +
          this.escapeHtml(variant.title) +
          (variant.available ? '' : ' - Sold Out') +
          '</option>';
      }
      html += '</select>';

      return html;
    },

    buildAddToCartHtml: function (variant, strings) {
      if (variant && variant.available) {
        return (
          '<a href="javascript:void(0);" class="add-to-cart ajax-spin-cart" data-variant-id="' +
          variant.id +
          '" title="' +
          this.escapeHtml(strings.addToCart) +
          '">' +
          '<span>' +
          '<span class="cart-title">' +
          this.escapeHtml(strings.addToCart) +
          '</span>' +
          '<span class="cart-loading animated infinite rotateOut"><i class="ion-load-a"></i></span>' +
          '<span class="cart-added">' +
          this.escapeHtml(strings.added) +
          '</span>' +
          '</span>' +
          '</a>'
        );
      }

      return (
        '<a class="disabled-add-to-cart out-of-stock" href="javascript:void(0)" title="' +
        this.escapeHtml(strings.outOfStock) +
        '">' +
        '<span class="cart-title">' +
        this.escapeHtml(strings.outOfStock) +
        '</span>' +
        '</a>'
      );
    },

    buildBuyNowHtml: function (variant, strings) {
      if (!variant || !variant.available) {
        return (
          '<a href="javascript:void(0)" class="instant-buy-btn is-disabled" title="' +
          this.escapeHtml(strings.outOfStock) +
          '">' +
          '<span>' +
          this.escapeHtml(strings.buyNow) +
          '</span></a>'
        );
      }

      return (
        '<a href="javascript:void(0)" class="instant-buy-btn" data-variant-id="' +
        variant.id +
        '" title="' +
        this.escapeHtml(strings.buyNow) +
        '">' +
        '<span>' +
        this.escapeHtml(strings.buyNow) +
        '</span></a>'
      );
    },

    renderProduct: function (product) {
      var strings = this.getStrings();
      var defaultVariant = this.getDefaultVariant(product);
      var productUrl = '/products/' + encodeURIComponent(product.handle);
      var imageUrl =
        product.featured_image || '//cdn.shopify.com/s/images/admin/no-image-compact.gif';
      var variantSelectorHtml = this.buildVariantSelectorHtml(product, defaultVariant);
      var addToCartHtml = this.buildAddToCartHtml(defaultVariant, strings);
      var buyNowHtml = this.buildBuyNowHtml(defaultVariant, strings);
      var priceHtml = this.buildPriceHtml(product);

      const html = `
        <form action="/cart/add" method="post" class="cart wishlist-item-form" enctype="multipart/form-data" id="add-item-form-${product.id}">
          <input type="hidden" class="wishlist-variant-id" name="id" value="${defaultVariant ? defaultVariant.id : ''}">
          <input type="hidden" name="quantity" value="1">
          <ul class="wishlist-tile-container" data-product-id="${product.id}" data-product-handle="${this.escapeHtml(product.handle)}">
            <li class="wishlist-info">
              <div class="item-img">
                <a href="${productUrl}">
                  <img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" loading="lazy">
                </a>
              </div>
              <div class="item-content">
              <div class="item-title">
                <a href="${productUrl}" title="${this.escapeHtml(product.title)}">
                  ${this.escapeHtml(product.title)}
                </a>
              </div>
               
                </div>
            </li>
            <li class="item-add-remove"> 
              <div class="item-add">
                ${addToCartHtml}
              </div>
              <div class="item-buy">
                ${buyNowHtml}
              </div>
            </li>
            <li class="item-price">
              <span class="product-price">
                ${priceHtml}
              </span>
              <span class="item-remove">
                <a class="action-wishlist wishlist-btn is-active" href="javascript:void(0)" data-product-handle="${this.escapeHtml(product.handle)}" data-wishlist-page-remove="true" title="Remove">
                  <span class="remove-wishlist"><i class="ion-android-close"></i></span>
                </a>
              </span>
            </li>
          </ul>
        </form>`;

      $(this.selectors.container).append(html);
    },

    showLoading: function () {
      $(this.selectors.loader).show();
      $(this.selectors.empty).removeClass('is_visible').hide();
      $(this.selectors.grid).removeClass('is_visible').hide();
    },

    hideLoading: function () {
      $(this.selectors.loader).hide();
    },

    showGrid: function () {
      $(this.selectors.empty).removeClass('is_visible').hide();
      $(this.selectors.grid).addClass('is_visible').show();
    },

    showEmpty: function () {
      this.hideLoading();
      $(this.selectors.container).empty();
      $(this.selectors.grid).removeClass('is_visible').hide();
      $(this.selectors.empty).addClass('is_visible').show();
    },

    syncCartCounter: function () {
      $.getJSON('/cart.js')
        .done(function (cart) {
          $('#cart-total, .bigcounter, .cart-count-item').text(cart.item_count);
        })
        .fail(function () {
          // Silent fail: counter sync is best effort.
        });
    },

    bindEvents: function () {
      var self = this;

      $(document).on('click.wishlistPage', '.wishlist-tile-container .wishlist-btn', function (event) {
        event.preventDefault();

        var handle = $(this).data('product-handle');
        var $form = $(this).closest('form');

        window.Wishlist.remove(handle);

        $form.fadeOut(200, function () {
          $(this).remove();
          if (!$('.wishlist-tile-container').length) {
            self.showEmpty();
          }
        });
      });

      $(document).on('click.wishlistPage', '.wishlist-clear-all', function (event) {
        event.preventDefault();

        if (!window.confirm(self.getStrings().confirmClear)) {
          return;
        }

        window.Wishlist.clear();
        self.showEmpty();
      });

      $(document).on('change.wishlistPage', '.wishlist-variant-select', function () {
        var variantId = $(this).val();
        var $form = $(this).closest('form');
        var $addToCartButton = $form.find('.add-to-cart');
        var $buyNowButton = $form.find('.instant-buy-btn');

        $form.find('.wishlist-variant-id').val(variantId || '');
        $addToCartButton.attr('data-variant-id', variantId || '');
        $buyNowButton.attr('data-variant-id', variantId || '');
      });

      $(document).on('click.wishlistPage', '.wishlist-tile-container .add-to-cart', function (event) {
        event.preventDefault();

        var $button = $(this);
        var variantId = $button.data('variant-id');

        if (!variantId || $button.hasClass('out-of-stock') || $button.hasClass('disabled-add-to-cart')) {
          return;
        }

        $button.addClass('loading');

        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            id: variantId,
            quantity: 1
          }
        })
          .done(function () {
            $button.removeClass('loading').addClass('added');
            self.syncCartCounter();

            window.setTimeout(function () {
              $button.removeClass('added');
            }, 1200);
          })
          .fail(function () {
            $button.removeClass('loading');
            window.alert(self.getStrings().addError);
          });
      });

      $(document).on('click.wishlistPage', '.instant-buy-btn', function (event) {
        event.preventDefault();

        var $button = $(this);
        var variantId = $button.data('variant-id');

        if (!variantId || $button.hasClass('is-disabled')) {
          return;
        }

        if ($button.hasClass('loading')) {
          return;
        }

        $button.addClass('loading');

        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            id: variantId,
            quantity: 1
          }
        })
          .done(function () {
            window.location.href = '/checkout';
          })
          .fail(function () {
            $button.removeClass('loading');
            window.alert(self.getStrings().addError);
          });
      });
    }
  };

  window.WishlistPage = WishlistPage;

  $(document).ready(function () {
    WishlistPage.init();
  });
})(window, window.jQuery);
